import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/table"

export const getTables = async queries => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const addTable = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const editTable = async (tableId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${tableId}`, data)

  return response.data
}

export const deleteTable = async (tableId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.delete(`${endpoint}/${tableId}`)

  return response.data
}